import { FC } from "react";

import { clsxMerge, getS3AssetPath } from "shared/lib/helpers";
import { ContactDetailI } from "shared/lib/interfaces/account";

import { ProspectInfoBlock } from "@/modules/pipeline/account-details/shared/prospect-info-block";
import { ProspectEditMenu } from "@/modules/pipeline/account-details/shared/prospect-edit-menu";

interface LeadItemPropsI {
  className?: string;
  contact: ContactDetailI;
}

export const AccountDetailsLeadItem: FC<LeadItemPropsI> = ({
  className,
  contact,
}) => {
  return (
    <div className={clsxMerge("flex w-full gap-2", className)}>
      <img
        alt="Lead Avatar"
        src={getS3AssetPath(
          "platform/account-details/lead-avatar-placeholder.webp"
        )}
        className="h-8 w-8"
      />

      <ProspectInfoBlock contact={contact} />

      <div className="flex items-start">
        <ProspectEditMenu contact={contact} />
      </div>
    </div>
  );
};
